const modules = import.meta.glob<{ default: string }>('./nachobot-*.jpg', { eager: true });

export const nachobotImages = Object.keys(modules)
  .sort((a, b) => {
    const na = parseInt(a.match(/nachobot-(\d+)/)?.[1] || '0');
    const nb = parseInt(b.match(/nachobot-(\d+)/)?.[1] || '0');
    return na - nb;
  })
  .map(k => modules[k].default);

import fp3d from './fp-3d.jpg';

export const nachobotFloorPlans = [
  { image: fp3d, label: "Půdorys – 3D" },
];
